// v1.28.11 — Soft two-tone "ping" chime for the Online Users panel when a
// new user comes online. Same shape as approveSound.js but gentler, and
// gated by its own mute key so admins can silence just this without also
// muting slip-approve chimes.
let _ctx = null;
function ctx() {
    if (_ctx) return _ctx;
    try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        _ctx = new AC();
    } catch { _ctx = null; }
    return _ctx;
}

const MUTE_KEY = "online_users_muted";
export const isNewUserChimeMuted = () => {
    try { return localStorage.getItem(MUTE_KEY) === "1"; } catch { return false; }
};
export const setNewUserChimeMuted = (v) => {
    try { localStorage.setItem(MUTE_KEY, v ? "1" : "0"); } catch { /* noop */ }
};

function tone(ac, freq, startAt, duration, gainPeak = 0.10) {
    const osc = ac.createOscillator();
    const gain = ac.createGain();
    osc.type = "sine";
    osc.frequency.setValueAtTime(freq, startAt);
    gain.gain.setValueAtTime(0.0001, startAt);
    gain.gain.exponentialRampToValueAtTime(gainPeak, startAt + 0.03);
    gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);
    osc.connect(gain).connect(ac.destination);
    osc.start(startAt);
    osc.stop(startAt + duration + 0.02);
}

/** Play a gentle two-note ping when a new user appears online. */
export function playNewUserChime() {
    if (isNewUserChimeMuted()) return;
    try {
        if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    } catch { /* noop */ }
    const ac = ctx();
    if (!ac) return;
    if (ac.state === "suspended") { try { ac.resume(); } catch { /* noop */ } }
    const now = ac.currentTime;
    // Gentle rising fifth — softer than the approve chime so it fades into the background.
    tone(ac, 660, now,        0.16, 0.09);   // E5
    tone(ac, 990, now + 0.09, 0.22, 0.10);   // B5
}
